/* eslint-disable no-console */
import axiosInstance from './axiosInstance';

export default async function fetchDeviceList(host) {
  try {
    // Fetch the list of devices
    const { data: deviceList } = await axiosInstance.get(`${window.location.protocol}//${host}/api/v1/sensor/list`);
    console.log('unfiltered sensor list:', deviceList);

    // Filter out devices with state 'removed'
    const filteredList = deviceList.filter((device) => !(Object.prototype.hasOwnProperty.call(device, 'state') && device.state === 'removed'));

    console.log('filtered sensor list:', filteredList);

    // Fetch sensor status map
    const { data: sensorStatusMap } = await axiosInstance.get(`${window.location.protocol}//${host}/api/v1/sensor/status`);

    // Create a list of authorized devices with their status
    const authorizedList = filteredList.map((device) => {
      const sensorStatus = sensorStatusMap[device.sensorId];
      if (sensorStatus) {
        const isAuthorized = sensorStatus.errorCode === 'NoError';
        return { ...device, isAuthorized };
      }
      return null; // No status found for this device
    }).filter((device) => device !== null);

    console.log('final authorized sensor list:', authorizedList);

    return authorizedList;
  } catch (error) {
    console.log('Failed to fetch device list', error.response);
    return null;
  }
}
